import { Stack, Text, Title } from '@buildex/ui';
import { useTranslation } from 'react-i18next';
import type { ModuleManifest } from '@buildex/module-contract';
import { LaunchTrack } from '@/widgets/launch-track/LaunchTrack';

interface HomePageProps {
  manifests: ModuleManifest[];
}

/**
 * Главная: «дорожка» запуска текущего объекта + блоки активных модулей
 * (сводные данные, список объектов — из manifest.home).
 */
export function HomePage({ manifests }: HomePageProps) {
  const { t } = useTranslation();
  const blocks = manifests.filter(
    (m): m is ModuleManifest & { home: NonNullable<ModuleManifest['home']> } =>
      m.home !== undefined,
  );

  return (
    <Stack gap="lg">
      <div>
        <Title order={2}>{t('home.title')}</Title>
        <Text size="sm" c="dimmed">
          {t('home.subtitle')}
        </Text>
      </div>

      <LaunchTrack manifests={manifests} />

      {blocks.map((manifest) => (
        <manifest.home key={manifest.id} />
      ))}
    </Stack>
  );
}
